<template>
  <div class="page-paper-detail">
    <tx-header></tx-header>
    <tx-bread-crumb></tx-bread-crumb>
    <el-container id="container" class="content mb30">
      <el-main class="mr20">
        <h1 class="tc f24 mt20 pl30 pr30">{{docInfo.docName}}</h1>
        <div class="tc f12 mt15 mb30" v-if="testList.length > 0">
          省份：{{docInfo.areaName}} <span class="ml5 mr5 text-color-3">|</span>
          <template v-if="docInfo.grade">年级：{{docInfo.grade}} <span class="ml5 mr5 text-color-3">|</span></template>
          类型：{{docInfo.docType}} <span class="ml5 mr5 text-color-3">|</span>
          <template v-if="docInfo.year != 0">试卷年份：{{docInfo.year}} <span class="ml5 mr5 text-color-3">|</span></template>
          上传日期：{{docInfo.loadTime}} <span class="ml5 mr5 text-color-3">|</span>
          数量：{{docInfo.testNum}} <span class="ml5 mr5 text-color-3">|</span>
          试卷编号：{{docInfo.docID}}
        </div>
        <tx-question-item
          ref="QuestionItem"
          :item="item" v-for="item in testListOrder"
          :key="item.testID"
          :itemSource="testList[testListItemIndex(item.testID)]"
          hasOrder
          page="paperDetail"
          show-grade
          show-error
        ></tx-question-item>
      </el-main>
      <el-aside width="260px" class="paper-aside">
        <tx-scroll-fixed>
          <div class="bd-3">
            <div class="btns mt10 ml15 mr15">
              <el-button type="primary" class="pct100 f16" size="large" v-before="{handler: bindAddAll}">全部添加到试题篮</el-button>
              <div class="flex-between mt10 pb10" style="border-bottom: 1px dashed #EBEEF5;">
                <el-button size="mini" class="w110" v-before="{handler: bindDownload}">下载试卷</el-button>
                <el-button size="mini" class="w110" @click="bindPaperAnalysis(computedPaperData.testList)">试卷分析</el-button>
              </div>
              <el-checkbox v-model="showAnswer" class="f12 mt10 mb10" @change="isShowAnswer">显示答案及解析</el-checkbox>
            </div>
            <!--试题组成-->
            <div class="ques-form">
              <div class="bg-body p15">
                <strong>试题组成</strong>
                <span class="f12 text-color-3 ml5">(题数：{{docInfo.testNum}})</span>
              </div>
              <div style="height:calc(100vh - 357px);" v-bar>
              <!--<div>-->
                <div class="ques-types bg-white">
                  <div class="ps-paper-part-item"
                       v-for="(composeItem, composeItemIndex) of computedPaperData.typeCompose"
                       :key="composeItem.id + composeItemIndex">
                    <!--<div class="paper-part-title">
                      {{composeItem.name}}
                    </div>-->
                    <div class="paper-part-content">
                      <!--相同题型key会重复，报错， 所以不能只用composeSubItem.id-->
                      <div class="ps-ques-list" :class="{mt10: composeSubIndex}"
                           v-for="(composeSubItem, composeSubIndex) of composeItem.sub"
                           :key="composeSubItem.id + '-' + composeSubIndex">
                        <div class="ques-name">
                          <template v-if="composeSubItem._countTypeOrder">
                            {{composeSubItem._countTypeOrder | uppercaseNumber}}、{{composeSubItem.name}}
                          </template>
                        </div>
                        <div class="order-list">
                          <el-popover
                            class="order-item un-select"
                            placement="bottom-start"
                            width="200"
                            trigger="hover"
                            :open-delay="250"
                            @click.native="$router.replace({name: $route.name, params: $route.params, query: $route.query, hash: `#question-order-${composeSubSubItem._startOrder}`})"
                            v-for="(composeSubSubItem) in composeSubItem.sub"
                            :key="composeSubSubItem.testID">
                            <div class="f12">
                              <div class="mb2 lh17"><span class="text-color-3">题号：</span>{{composeSubSubItem.testID}}
                              </div>
                              <div class="mb2 lh17"><span class="text-color-3">题型：</span>{{composeSubItem.name}}
                              </div>
                              <div class="mb2 lh17"><span class="text-color-3">难度：</span>{{composeSubSubItem.diffName}}[{{composeSubSubItem.diff}}]
                              </div>
                              <div class="lh14"><span class="text-color-3">来源：</span>{{testListMaps[composeSubSubItem.testID].docName}}
                              </div>
                            </div>
                            <div slot="reference">
                              {{composeSubSubItem._countOrder}}
                            </div>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tx-scroll-fixed>
      </el-aside>
    </el-container>
    <!--试卷分析-->
    <tx-msg-box class="paper-analysis-pop" ref="paperAnalysisDialog"
                :options="{title: '试卷分析', showConfirmButton: false, align: 'tl' , type: 'custom', showClose: true, width: '840px'}">
      <paper-analysis ref="paperAnalysis" :data="paperAnalysisData"></paper-analysis>
    </tx-msg-box>
  </div>
</template>

<style lang="less">
  @import "../styles/_mixins-wln";
  .page-paper-detail {
    .el-main{
      padding: 0;
    }
    .w110{
      width: 110px;
    }
    #container{
      min-height: 200px;
    }
    .paper-aside{
      .el-checkbox__label{
        font-size: 12px;
      }
    }
    .ques-types{
      padding: 10px 3px 3px;
      .ps-paper-part-item {
        font-size: 12px;
        padding: 0 10px 10px;

        .paper-part-title {
          padding: 12px 0;
        }
      }

      .ps-ques-list {
        /*border-top: 1px dashed #ddd;*/

        .ques-name {
          padding: 2px 0 10px;
        }

        .order-list {
          display: flex;
          flex-wrap: wrap;
          margin: -5px;

          .order-item {
            display: inline-block;
            min-width: 30px;
            height: 30px;
            text-align: center;
            padding: 0 3px;
            line-height: 28px;
            border-radius: 2px;
            border: 1px solid #eee;
            cursor: pointer;
            margin: 5px;

            &:hover {
              background-color: @primary;
              color: #fff;
              border-color: @primary;
            }
          }
        }
      }
    }
  }
  .paper-analysis-pop .message-box{
    padding: 0;
    .title{
      padding: 0 30px;
    }
  }
</style>

<script>
  /*!*
   * @author yueheqin
   * @date 2019/7/11
   * @project zujuanzaixian
   * @desc 试卷详情-挑选试题
   */
  import {mxmjTestListApi} from '../api/zujuan'
  import {createKeyMap} from '../utils/create-maps'
  import {mapMutations, mapGetters} from 'vuex'
  import PaperAnalysis from './paper/alert-paper-analysis.vue'
  import { countTestListOrder, paperAnalysisMixin } from '../mixins/zj-paper'
  import {MixinMetaInfo} from '../mixins/meta-info'

  export default {
    name: 'page-paper-detail',
    mixins: [paperAnalysisMixin, MixinMetaInfo],
    data () {
      return {
        testList: [],
        docInfo: {},
        testNum: 0,
        typeCompose: {},
        showAnswer: false
      }
    },
    components: {
      PaperAnalysis
    },
    computed: {
      ...mapGetters('common', ['currentSubject']),
      subjectID () {
        return this.currentSubject.id
      },
      docID () {
        return this.$route.query.docID
      },
      computedPaperData () {
        let testList = []
        let testIDList = []
        let typeCompose = this.typeCompose
        let testListMaps = createKeyMap(countTestListOrder(this.testList), 'testID')
        let quesOrder = 0
        let quesTypeOrder = 0
        _.each(typeCompose, item => {
          _.each(item.sub, subItem => {
            subItem._countTestNum = _.reduce(_.map(subItem.sub, countItem => countItem.testNum), (a, b) => Number(a) + Number(b))
            subItem._countScore = _.reduce(_.flatten(_.map(subItem.sub, countItem => countItem.score)), (a, b) => Number(a) + Number(b))
            quesTypeOrder++
            subItem._countTypeOrder = quesTypeOrder
            _.each(subItem.sub, subSubItem => {
              testList.push(_.assign({}, testListMaps[subSubItem.testID], subSubItem))
              // testList.push(testListMaps[subSubItem.testID])
              testIDList.push(subSubItem.testID)
              let _orderStart = quesOrder + 1
              let _orderEnd = quesOrder + subSubItem.testNum
              subSubItem._startOrder = _orderStart
              subSubItem._countOrder = _orderStart === _orderEnd ? _orderStart : `${_orderStart}-${_orderEnd}`
              quesOrder += subSubItem.testNum
            })
          })
        })
        return {
          quesTypeNum: quesTypeOrder,
          // testListMaps,
          testList,
          testIDList,
          typeCompose
        }
      },
      testListMaps () {
        return createKeyMap(countTestListOrder(this.testList), 'testID')
      },
      testListOrder () {
        return countTestListOrder(this.testList)
      }
    },
    created () {
      let prevRouter
      let prePage = this.$route.query.prePage
      if (prePage === 'search') {
        prevRouter = {
          name: 'Search',
          title: '搜索'
        }
      } else if (prePage === 'mxmj') {
        prevRouter = {
          name: 'MXMJ',
          title: '名校名卷'
        }
      }
      if (prevRouter) {
        this.$route.meta.prevRouter = prevRouter
      }
      this.getData()
    },
    methods: {
      ...mapMutations('pop', ['updatePaperDownPopVisible', 'updateCurrentDownDoc']),
      ...mapMutations('basket', ['addAllQuesBasket']),
      getData () {
        let vm = this
        mxmjTestListApi({docID: vm.docID}, {loading: '#container'}).then(({data}) => {
          vm.testList = data.testList
          vm.pageName = vm.pageName + data.docInfo.docName
          vm.docInfo = data.docInfo
          vm.testNum = data.docInfo.testNum
          vm.typeCompose = data.paper.typeCompose
        })
      },
      isShowAnswer (val) {
        _.each(this.$refs.QuestionItem, item => {
          item.bindShowAnswer(val)
        })
      },
      // 下载
      bindDownload () {
        this.updateCurrentDownDoc(this.docID)
        this.updatePaperDownPopVisible(true)
      },
      // 全部加入试题篮
      bindAddAll () {
        if (this.docInfo.subjectID != this.subjectID) {
          this.$message.error('当前试卷学科与所选学科不一致，请切换学科之后添加试题！')
          return
        }
       this.addAllQuesBasket(this.testList)
      },
      testListItemIndex (testID) {
        return _.findIndex(this.testList, {'testID': testID})
      }
    }
  }
</script>
